/* eslint-disable no-template-curly-in-string */
import React, { useState, useRef, useEffect } from "react";
import * as UMSService from "services/umsService";
import { Button, Modal, Table, Input, InputGroup } from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import CreateUser from "../ForGroupUsers/CreateUserForGroup/CreateUserForGroup";
import UpdateUser from "../ForGroupUsers/UpdateUserForGroup/UpdateUserForGroup";

const UserListForGroup = (props: any) => {
  const { userContext, handleSpinner } = props;
  const { Column, HeaderCell, Cell } = Table;
  const [userList, setUserList] = useState([]);
  const [updateUserData, setUpdateUserData] = useState([]);
  const [filteredUserList, setFilteredUserList] = useState(null);
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseUpdate = () => {
    setOpenUpdate(false);
  };
  useEffect(() => {
    if (userContext && userContext.groupType) {
      GetUserList(userContext && userContext.groupType);
    }
  }, [userContext]);

  const GetUserList = async (groupTypeId) => {
    handleSpinner && handleSpinner(true);
    UMSService.GetUserListForGroup(groupTypeId)
      .then((result) => {
        result.map((item) => {
          if (item.store_id === 0) {
            return (item.store_id = "");
          }
        });
        result.sort(function(a, b) {
          return b.uid - a.uid;
      });
        setUserList(result);

        result && handleSpinner && handleSpinner(false);
      })
      .catch((err) => {
        console.error("Error:  - ", err);
        err && handleSpinner && handleSpinner(false);
        // toast.error("Error Loading Orders");
      });
  };

  const DeleteUser = (userID) => {
    UMSService.DeleteUser(userID)
      .then((result) => {
        //console.log(result);
        result && window.location.reload();
      })
      .catch((err) => {
        console.error("Error:  - ", err);
        // toast.error("Error Loading Orders");
      });
    return console.log(userID.toString());
  };
  const filterUserList = (value) => {
    if (value) {
      setFilteredUserList(
        userList.filter((item) =>
          String(item.email)
            .toLowerCase()
            .includes(value.toString().toLowerCase())
        )
      );
    }
  };
  const editfunction = (rowdataUID) => {
    setUpdateUserData(userList.filter((user) => user.uid === rowdataUID));
    setOpenUpdate(true);
  };
  if (userContext) {
    var { roleName } = userContext;
  }
  if (roleName === "Admin" || roleName === "Super Admin") {
    return (
      <>
        <div className="User-Management">
          <Button appearance="primary" onClick={() => setOpen(true)}>
            Create New User
          </Button>

          <InputGroup
            onChange={(event) => {
              filterUserList(event.target.value);
            }}
            style={{
              width: 200,
              height: 40,
            }}
          >
            <Input placeholder="Filter email" />
            <InputGroup.Button>
              <SearchIcon />
            </InputGroup.Button>
          </InputGroup>

          {/* <InputGroup
            onChange={(event) => {
              filterUserList(event.target.value);
            }}
            style={styles}
          >
              <Tag  color="blue">Filter email</Tag>
              <Input />
            <InputGroup.Button>
              <SearchIcon />
            </InputGroup.Button>
          </InputGroup> */}
        </div>

        <Table
          height={800}
          data={filteredUserList ? filteredUserList : userList}
          /* onRowClick={(rowData) => {
            //console.log(rowData);
          }} */
        >
          <Column width={150} align="center" fixed>
            <HeaderCell>ID</HeaderCell>
            <Cell dataKey="uid" />
          </Column>

          <Column width={150}>
            <HeaderCell>First Name</HeaderCell>
            <Cell dataKey="first_Name" />
          </Column>

          <Column width={150}>
            <HeaderCell>Last Name</HeaderCell>
            <Cell dataKey="last_Name" />
          </Column>
          <Column width={300}>
            <HeaderCell>Email</HeaderCell>
            <Cell dataKey="email" />
          </Column>

          <Column width={150}>
            <HeaderCell>Role Name</HeaderCell>
            <Cell dataKey="role_Name" />
          </Column>
          <Column width={150}>
            <HeaderCell>Group Type</HeaderCell>
            <Cell dataKey="group_type_desc" />
          </Column>

          <Column width={200}>
            <HeaderCell>Group Name</HeaderCell>
            <Cell dataKey="group_ID_Desc" />
          </Column>
          <Column width={100}>
            <HeaderCell>Store ID</HeaderCell>
            <Cell dataKey="store_id" />
          </Column>

          <Column width={80} fixed="right">
            <HeaderCell>Edit User</HeaderCell>

            <Cell style={{ padding: "6px" }}>
              {(rowData) => (
                <Button
                  appearance="link"
                  // onClick={() => alert(`id:${rowData.uid}`)}
                  onClick={() => editfunction(rowData.uid)}
                >
                  Edit
                </Button>
              )}
            </Cell>
          </Column>
          <Column width={120} fixed="right">
            <HeaderCell>Delete User</HeaderCell>

            <Cell style={{ padding: "6px" }}>
              {(rowData) => (
                <Button
                  color="red"
                  appearance="ghost"
                  onClick={() =>
                    // eslint-disable-next-line no-restricted-globals
                    confirm(
                      `Are you sure to delete ${rowData.first_Name}  ${rowData.last_Name} `
                    ) && DeleteUser(rowData.uid.toString())
                  }
                >
                  Delete
                </Button>
              )}
            </Cell>
          </Column>
        </Table>

        {/* <TableComponentUserList
          isFromModal={false}
          tableDetails={UserListConstants["UserListConstants"]}
          reportList={userList}
          iconColumn={""}
          onTableRowClick={() => {}}
          reportType={""}
          isTotalRowRequired={false}
        /> */}

        <Modal open={open} onClose={handleClose} size="md">
          <Modal.Header></Modal.Header>
          <Modal.Body>
            <div style={{ textAlign: "center" }}>
              <CreateUser
                userContext={userContext}
                handleSpinner={handleSpinner}
              />
            </div>
          </Modal.Body>
        </Modal>

        <Modal open={openUpdate} onClose={handleCloseUpdate} size="md">
          <Modal.Header></Modal.Header>
          <Modal.Body>
            <div style={{ textAlign: "center" }}>
              <UpdateUser
                userData={updateUserData[0]}
                userContext={userContext}
                handleSpinner={handleSpinner}
              />
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  } else {
    return <div>You have to contact Admin</div>;
  }
};
export default UserListForGroup;
